import apiInstance from "@api/apiInstance";
import { StudyWordsFilters, WordStudy } from "interfaces/Vocabulary/VocabularyInterfaces";

export const fetchVocabularyProgress = async (startSeminary: number, endSeminary: number) => {
	return apiInstance
		.get(`vocabulary/progress?startSeminary=${startSeminary}&endSeminary=${endSeminary}`)
		.then((res) => {
			return res.data;
		});
};

export const fetchProgressLanguageBySeminary = async (startSeminary: number, endSeminary) => {
	return apiInstance
		.get(`vocabulary/progress-languages?startSeminary=${startSeminary}&endSeminary=${endSeminary}`)
		.then((res) => {
			return res.data;
		});
};

export const fetchWordsBySeminaryAndLanguage = async (
	language: string,
	startSeminary: number,
	endSeminary: number
) => {
	return apiInstance
		.get(
			`vocabulary/language-words?language=${language}&startSeminary=${startSeminary}&endSeminary=${endSeminary}`
		)
		.then((res) => {
			return res.data;
		});
};

export const fetchWordProgress = async (wordDataId: number) => {
	return apiInstance.get(`vocabulary/word-progress/${wordDataId}`).then((res) => {
		return res.data;
	});
};

export const fetchVocabularyStreakAndDays = async (userId: string, timezone: string) => {
	return apiInstance
		.get(`user/${userId}/streak`, { params: { timezone: timezone } })
		.then((res) => {
			return res.data;
		});
};

export const migrateVocabularyStudiedDays = async (
	userId: string,
	dates: string[],
	timezone: string
) => {
	return apiInstance
		.post(`user/${userId}/migrate-firestore`, { timezone: timezone, firestoreDates: dates })
		.then((res) => {
			return res.data;
		});
};

export const addVocabularyStudiedDay = async (userId: string, date: string, timezone: string) => {
	return apiInstance.post(`user/${userId}/study-day`, { studyDate: date, timezone }).then((res) => {
		return res.data;
	});
};

export const registerWordsStudied = async (
	userId: string,
	seminaryId: number,
	studied_words: WordStudy[]
) => {

	console.log("userId",userId,"seminaryId",seminaryId, "studied_words", studied_words);
	const res = await apiInstance.post(`study-history`, {
		user_id: userId,
		seminary_id:seminaryId,
		studied_words,
	});
	return res.data;
};

export const getWordStudiedPerPeriod = async (params: StudyWordsFilters) => {
	const res = await apiInstance.get(`study-history`, { params: params });
	return res.data;
};
